// Tracking GTM dei form di contatto del layout 2026.
// Stato avanzamento: vedi docs/2026-layout-CHANGELOG.md
//
// Il form di tutte le pagine 2026 è lo stesso include (contacts::_fields) e viene
// inviato in POST classico: Modules/Contacts/.../PublicController@store fa
// redirect()->back() con un flash 'notification' (successo) oppure withErrors()
// (errore). core::public.master_2026 rende quel flash come popup #info-msg con
// classe .flash-success / .flash-error. Non esiste una thank-you page: l'unico
// segnale affidabile di conversione è quel popup.
//
// Di conseguenza il contesto del form (quale pagina, quale settore) viene
// memorizzato in sessionStorage al submit e riletto al caricamento successivo.
//
// Eventi spinti nel dataLayer:
//   form_start     — primo focus su un campo del form
//   form_submit    — submit inviato (non implica successo)
//   generate_lead  — popup di successo presente dopo il redirect
//   form_error     — popup di errore presente dopo il redirect

(function () {
    var STORAGE_KEY = 'wc_form_pending';

    window.dataLayer = window.dataLayer || [];

    function push(payload) {
        window.dataLayer.push(payload);
    }

    // Il campo hidden 'type' identifica già la pagina di origine
    // (homepage, chi-siamo, info, cleve, alicon, mixer, tr.asset).
    function contextOf(form) {
        if (!form) {
            return null;
        }
        var type = form.querySelector('input[name="type"]');
        var sector = form.querySelector('select[name="sector"]');
        return {
            form_location: type ? type.value : 'unknown',
            sector: sector && sector.value ? sector.value : 'none',
            page_path: window.location.pathname,
            language: document.documentElement.lang || 'it',
        };
    }

    function readPending() {
        try {
            var raw = window.sessionStorage.getItem(STORAGE_KEY);
            return raw ? JSON.parse(raw) : null;
        } catch (e) {
            return null;
        }
    }

    function writePending(ctx) {
        try {
            window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(ctx));
        } catch (e) { /* sessionStorage non disponibile: si usa il fallback DOM */ }
    }

    function clearPending() {
        try {
            window.sessionStorage.removeItem(STORAGE_KEY);
        } catch (e) { /* noop */ }
    }

    /* ── 1. form_start + form_submit ── */

    var forms = document.querySelectorAll('form.cta-form');

    forms.forEach(function (form) {
        var started = false;

        form.addEventListener('focusin', function (e) {
            if (started || !e.target.matches('input, select, textarea')) {
                return;
            }
            started = true;
            push(Object.assign({ event: 'form_start' }, contextOf(form)));
        });

        form.addEventListener('submit', function () {
            var ctx = contextOf(form);
            writePending(ctx);
            push(Object.assign({ event: 'form_submit' }, ctx));
        });
    });

    /* ── 2. generate_lead / form_error dopo il redirect ── */

    var popup = document.getElementById('info-msg');
    if (!popup) {
        return;
    }

    // Fallback se sessionStorage è vuoto: il redirect è ->back(), quindi il form
    // di origine è ancora presente in pagina.
    var ctx = readPending() || contextOf(document.querySelector('form.cta-form')) || {
        form_location: 'unknown',
        sector: 'none',
        page_path: window.location.pathname,
        language: document.documentElement.lang || 'it',
    };

    if (popup.classList.contains('flash-success')) {
        clearPending();
        push(Object.assign({ event: 'generate_lead' }, ctx));
    } else if (popup.classList.contains('flash-error')) {
        var messages = Array.prototype.map.call(
            popup.querySelectorAll('li'),
            function (li) { return li.textContent.trim(); }
        );
        push(Object.assign({
            event: 'form_error',
            error_count: messages.length,
            error_message: messages.join(' | ').slice(0, 200),
        }, ctx));
    }
})();
